import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AssignmentHistoryComp from "./Component/AssignmentHistoryComp"

const AssignmentHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <AssignmentHistoryComp/>
        </div>
        <Footer />
        </>
    )
}

export default AssignmentHistory